import { Injectable } from '@angular/core';
import { NgbDate, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';

const I18N_VALUES = {
  es: {
    weekdays: ['lun', 'mar', 'mié', 'jue', 'vie', 'sáb', 'dom'],
    months: [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre'
    ],
    weekLabel: 'sem'
  }
};

@Injectable({ providedIn: 'root' })
export class NgbDatepickerI18nEs extends NgbDatepickerI18n {
  private readonly locale = I18N_VALUES.es;

  getWeekdayShortName(weekday: number): string {
    return this.locale.weekdays[weekday - 1];
  }

  override getMonthShortName(month: number): string {
    return this.locale.months[month - 1].slice(0, 3);
  }

  override getMonthFullName(month: number): string {
    return this.locale.months[month - 1];
  }

  override getWeekdayLabel(weekday: number, width?: 'long' | 'short' | 'narrow'): string {
    const label = this.locale.weekdays[weekday - 1];
    if (width === 'narrow') {
      return label.charAt(0);
    }
    return label;
  }

  override getWeekLabel(): string {
    return this.locale.weekLabel;
  }

  override getDayAriaLabel(date: NgbDate): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}
